import { actionCreators } from "./actionCreators";
import { reducer } from "./reducer";

const globalStore = {
    actionCreators,
    reducer
}

export default globalStore;